import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import styled from "styled-components";

export const StyledSelect = styled(Select)<{ hasInputLabel?: boolean }>`
  && {
    border: 1px solid #b9b9b9;
    padding: 14px;
    border-radius: 5px;
    &:before {
      border-bottom-width: 0px !important;
    }
    &:after {
      border-bottom-width: 0px !important;
    }
  }
`;

export const StyledInputLabel = styled(InputLabel)`
  && {
    pointer-events: none;
    color: #aeaeae;
    font-size: 16px;
    padding-top: 14px;
  }

  &&.MuiInputLabel-shrink {
    background: white;
    z-index: 1;
  }
`;
